import { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import PageHeader from '@zenbusiness/zui/PageHeader';
import PageLoading from '@zenbusiness/zui/PageLoading';

import * as Styled from './BillingLayout.styles';
import BillingTabs from './BillingTabs';

const LOCALIZED_TEXT = {
  heading: 'dashboard.billing.heading',
};

function BillingLayout() {
  return (
    <Styled.Root>
      <PageHeader
        title={<FormattedMessage id={LOCALIZED_TEXT.heading} />}
        slots={{
          end: <BillingTabs />,
        }}
      />
      <Suspense fallback={<PageLoading />}>
        <Outlet />
      </Suspense>
    </Styled.Root>
  );
}

export default BillingLayout;
